<div class="flex flex-column justify-content-start">
  <div class="flex flex-column align-items-center justify-content-center" style="min-height: 50px !important;">
    <app-menu [menu]="menu"></app-menu>
  </div>
  <div [style.margin-bottom.px]="40" class="flex flex-column justify-content-center h-full" *ngIf="elaborazioneService.isCheckingElaborazione()==false">
    <app-button *ngIf="shortcut1" [icon]="shortcut1.icon" [routerLink]="shortcut1.link"></app-button>
    <app-button *ngIf="shortcut2" [icon]="shortcut2.icon" [routerLink]="shortcut2.link"></app-button>
    <app-button *ngIf="shortcut3" [icon]="shortcut3.icon" [routerLink]="shortcut3.link"></app-button>
  </div>
</div>
